'use client';

import { useRouter } from 'next/navigation';
import { useState, type FormEvent } from 'react';
import { Input } from '@/lib/components/ui/input';
import { Button } from '@/lib/components/ui/button';
import type { Dictionary } from '@/lib/server/getDictionary';
import type { Locale } from '@/lib/config/i18n-config';

type Props = {
  locale: Locale;
  dictionary: Dictionary;
};

export function TrackingSearchForm({ locale, dictionary }: Props) {
  const router = useRouter();
  const [value, setValue] = useState('');

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) return;
    router.push(`/${locale}/${encodeURIComponent(trimmed)}`);
  }

  return (
    <div className="mx-auto mt-8 w-full max-w-sm text-left">
      <form
        onSubmit={handleSubmit}
        className="flex items-center rounded-xl border border-outline-variant bg-surface pr-1 focus-within:ring-2 focus-within:ring-primary"
      >
        <Input
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder={dictionary.general.trackingNumberPlaceholder}
          aria-label={dictionary.general.trackingNumber}
          className="h-11 border-0 bg-transparent focus-visible:ring-0"
        />
        <Button type="submit" size="sm" className="rounded-lg">
          {dictionary.general.track}
        </Button>
      </form>
      <p className="mt-2 flex items-center gap-1.5 text-xs text-on-surface-variant">
        <span className="material-symbols-outlined shrink-0 text-sm leading-none">info</span>
        {dictionary.general.trackingNumberHint}
      </p>
    </div>
  );
}
